import { useLocalStorageValue } from '@react-hookz/web';
import { track } from '@/lib/analytics/client';

export type Tour = { skipped: boolean; lastStep: number; done: boolean };

const defaultTour: Tour = { skipped: false, lastStep: 0, done: false };

const useTour = () => {
  const {
    value,
    set: setValue,
    remove: removeValue,
  } = useLocalStorageValue<Tour>('headlinker-tutorial', { defaultValue: defaultTour, initializeWithValue: false });

  const resetTour = () => {
    track('tour.start');
    setValue(defaultTour);
  };

  const goToNextStep = () => {
    track('tour.step.next', { step: (value?.lastStep || 0) + 1 });
    if (value) setValue({ ...value, lastStep: value.lastStep + 1 });
  };
  const stopTour = () => {
    track('tour.stop', { step: value });
    if (value) setValue({ ...value, skipped: true, done: true });
  };

  return { tour: value, setTour: setValue, removeTour: removeValue, resetTour, goToNextStep, stopTour };
};

export default useTour;
